(() => {
  const mobileQuery = window.matchMedia('(max-width: 1160px)');

  const shopMenu = document.querySelector('[data-h3d-shop-menu]');
  const shopToggle = shopMenu?.querySelector('[data-h3d-shop-subnav-toggle]');
  const shopSubnav = shopMenu?.querySelector('[data-h3d-shop-subnav]');

  const setShopMenuOpen = (open) => {
    if (!shopMenu || !shopToggle) return;
    shopMenu.classList.toggle('is-open', open);
    shopToggle.setAttribute('aria-expanded', String(open));
    shopToggle.setAttribute(
      'aria-label',
      open ? 'Shop-Kategorien schließen' : 'Shop-Kategorien öffnen',
    );
  };

  if (shopMenu && shopToggle && shopSubnav) {
    shopToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setShopMenuOpen(!shopMenu.classList.contains('is-open'));
    });

    document.addEventListener('click', (event) => {
      if (!shopMenu.contains(event.target)) setShopMenuOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !shopMenu.classList.contains('is-open')) return;
      setShopMenuOpen(false);
      shopToggle.focus();
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-h3d-nav-toggle]')) {
        setShopMenuOpen(false);
      }
    });

    shopSubnav.addEventListener('click', (event) => {
      if (mobileQuery.matches && event.target.closest('a')) {
        setShopMenuOpen(false);
      }
    });

    const resetShopMenu = () => setShopMenuOpen(false);
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', resetShopMenu);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(resetShopMenu);
    }
  }

  // Collection sort: respond immediately instead of waiting for Dawn's filter debounce.
  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement) || target.name !== 'sort_by') return;

      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', target.value);
      params.delete('page');

      const query = params.toString();
      window.location.assign(`${window.location.pathname}${query ? `?${query}` : ''}`);
    },
    true,
  );
})();
